'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './champs.routes';

//import 'angular-xeditable';

import MyChampsController from './mychamps.controller';
import ChampAddController from './champ_add.controller';
import ChampEditController from './champ_edit.controller';
import ChampCommonController from './champ_common.controller';
import ChampResultEditController from './champ_resultedit.controller';
import ChampCategoryEditController from './champ_categoryedit.controller';

export default angular.module('everlaps.champs_admin', [uiRouter/*, "xeditable"*/])
	.config(routing)
	.controller('MyChampsController', MyChampsController)
	.controller('ChampAddController', ChampAddController)
	.controller('ChampEditController', ChampEditController)
	.controller('ChampCommonController', ChampCommonController)
	.controller('ChampResultEditController', ChampResultEditController)
	.controller('ChampCategoryEditController', ChampCategoryEditController)
	.run(function($templateCache, editableOptions) {
		'ngInject';
		// http://blog.johnnyreilly.com/2016/05/inlining-angular-templates-with-webpack.html
		$templateCache.put("champ_common.html", require("./champ_common.html"));

		// angular-xeditable configuration
		editableOptions.theme = 'bs3';
	})
	.name;




// WEBPACK FOOTER //
// ./client/app/backend/champs/index.js